import {Route, Routes} from "react-router-dom";

import MainLayout from "../components/layout/maninLayout/MainLayout";
import ProtectedRoute from "./ProtectedRoute";

import RegisterPage from "../pages/Auth/register/RegisterPage";
import RegisterConfirmPage from "../pages/Auth/register/RegisterConfirmPage";
import SubjectBasePage from "../pages/Subjects/SubjectBasePage";
import TeacherPanelPage from "../pages/Subjects/TeacherPanelPage";
import SubjectDetailPage from "../pages/Subjects/subjectBaseDetail/SubjectDetailPage";

import LessonPanelPage from "../pages/Lessons/LessonPanelPage";
import MyLessonsPage from "../pages/Lessons/MyLessonsPage";

import AnalyticsPage from "../pages/Analytics/AnalyticsPage";
import LoginGate from "../pages/Auth/LoginGate";
import UnauthorizedPage from "../pages/Common/UnauthorizedPage";
import AddressesPage from "../pages/Settings/AddressesPage";
import MyAccountPage from "../pages/Settings/MyAccountPage";
import SettingsPage from "../pages/Settings/SettingsPage";
import SubscriptionPage from "../pages/Settings/SubscriptionPage";
import InvoicesPage from "../pages/Settings/InvoicesPage";
import UserPanelPage from "../pages/Users/UsersPage";

import LandingPage from "../pages/LandingPage/LandingPage";
import AgreementPage from "../pages/legal/AgreementPage";
import StudentPanelPage from "../pages/Students/StudentPanelPage";
import StudentDetailPage from "../pages/Students/studentDetail/StudentDetailPage";
import UserDetailPage from "../pages/Users/UserDetail/UserDetailPage";
import ExamPanelPage from "../pages/exam/ExamPanelPage";
import ExamDetailPage from "../pages/exam/examDetailPage/ExamDetailPage";
import ExamBasePage from "../pages/examBase/ExamBasePage";
import ExamBaseQuestionsPage from "../pages/examBase/examBaseQuestionsPage/ExamBaseQuestionsPage";
import ExamWizardPage from "../pages/examWizard/ExamWizardPage";
import ExamSessionPage from "../pages/exams/examSession/ExamSessionPage";
import MyExamsPage from "../pages/exams/myExamPage/MyExamsPage";
import ExamAttemptDetailPage from "../pages/exams/myExamPage/examAttemptsPage/ExamAttemptDetailPage";
import ExamAttemptDetailStudentPage from "../pages/exams/myExamPage/examAttemptsPage/ExamAttemptDetailStudentPage";
import ExamAttemptsPage from "../pages/exams/myExamPage/examAttemptsPage/ExamAttemptsPage";
import ForgotPasswordPage from "../pages/Auth/forgot-password/ForgotPasswordPage";
import ForgotPasswordConfirmPage from "../pages/Auth/forgot-password/ForgotPasswordConfirmPage";
import ForgotPasswordSetNewPasswordPage from "../pages/Auth/forgot-password/ForgotPasswordSetNewPasswordPage";
import QuestionBasePage from "../pages/QuestionBase/QuestionBasePage";
import QuestionImportPage from "../pages/QuestionImport/QuestionImportPage";
import PaymentCallback from "../pages/PaymentCallback";

const Router = () => {
    return (
        <Routes>
            <Route path="/login" element={<ProtectedRoute roles={["PUBLIC"]} element={<LoginGate/>}/>}/>
            <Route path="/forgot-password"
                   element={<ProtectedRoute roles={["PUBLIC"]} element={<ForgotPasswordPage/>}/>}/>
            <Route path="/forgot-password/confirm"
                   element={<ProtectedRoute roles={["PUBLIC"]} element={<ForgotPasswordConfirmPage/>}/>}/>
            <Route path="/forgot-password/set-new-password"
                   element={<ProtectedRoute roles={["PUBLIC"]} element={<ForgotPasswordSetNewPasswordPage/>}/>}/>
            <Route path="/register" element={<ProtectedRoute roles={["PUBLIC"]} element={<RegisterPage/>}/>}/>
            <Route path="/register/confirm"
                   element={<ProtectedRoute roles={["PUBLIC"]} element={<RegisterConfirmPage/>}/>}/>

            <Route
                path="/subjects/base"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <SubjectBasePage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/subjects/:id"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <SubjectDetailPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/subjects/teachers"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR"]}
                        element={
                            <MainLayout>
                                <TeacherPanelPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/students"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <StudentPanelPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/lessons"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <LessonPanelPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/my-lessons"
                element={
                    <ProtectedRoute
                        roles={["STUDENT"]}
                        element={
                            <MainLayout>
                                <MyLessonsPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/question-bank"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <QuestionBasePage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/question-bank/import"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <QuestionImportPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exams/base"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <ExamBasePage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exams/panel"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <ExamPanelPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exams/wizard"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <ExamWizardPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exams/wizard/:examBaseId"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <ExamWizardPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/analytics"
                element={
                    <ProtectedRoute
                        roles={["ADMIN"]}
                        element={
                            <MainLayout>
                                <AnalyticsPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/users"
                element={
                    <ProtectedRoute
                        roles={["ADMIN"]}
                        element={
                            <MainLayout>
                                <UserPanelPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/settings/account"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER", "STUDENT"]}
                        element={
                            <MainLayout>
                                <MyAccountPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/settings/addresses"
                element={
                    <ProtectedRoute
                        roles={["ADMIN"]}
                        element={
                            <MainLayout>
                                <AddressesPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/settings"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER", "STUDENT", "OWNER"]}
                        element={
                            <MainLayout>
                                <SettingsPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/settings/subscription"
                element={
                    <ProtectedRoute
                        roles={["ADMIN"]}
                        element={
                            <MainLayout>
                                <SubscriptionPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/settings/invoices"
                element={
                    <ProtectedRoute
                        roles={["ADMIN"]}
                        element={
                            <MainLayout>
                                <InvoicesPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exam-bases/:id/questions"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <ExamBaseQuestionsPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exams/:id"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER", "STUDENT"]}
                        element={
                            <MainLayout>
                                <ExamDetailPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exams/my"
                element={
                    <ProtectedRoute
                        roles={["STUDENT"]}
                        element={
                            <MainLayout>
                                <MyExamsPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exam-session/:examId"
                element={
                    <ProtectedRoute
                        roles={["STUDENT"]}
                        element={
                            <MainLayout>
                                <ExamSessionPage/>
                            </MainLayout>
                        }
                    />
                }
            />
            <Route
                path="/exam-attempts/exam/:examId"
                element={
                    <ProtectedRoute
                        roles={["STUDENT"]}
                        element={
                            <MainLayout>
                                <ExamAttemptsPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exam-attempts/:examId/student/:studentNumber"
                element={
                    <ProtectedRoute
                        roles={["OWNER", "ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <ExamAttemptsPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exam-attempts/:attemptId/detail"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <ExamAttemptDetailPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/exam-attempts/:attemptId/logs"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER", "STUDENT"]}
                        element={
                            <MainLayout>
                                <ExamAttemptDetailStudentPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/students/:studentNumber"
                element={
                    <ProtectedRoute
                        roles={["ADMIN", "COORDINATOR", "TEACHER"]}
                        element={
                            <MainLayout>
                                <StudentDetailPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route
                path="/users/:id"
                element={
                    <ProtectedRoute
                        roles={["ADMIN"]}
                        element={
                            <MainLayout>
                                <UserDetailPage/>
                            </MainLayout>
                        }
                    />
                }
            />

            <Route path="/payment/callback" element={<PaymentCallback/>}/>

            <Route path="/unauthorized" element={<UnauthorizedPage/>}/>
            <Route path="/terms" element={<AgreementPage/>}/>
            <Route path="*" element={<LandingPage/>}/>
        </Routes>
    );
};

export default Router;
